export const EyeIcon = ({ width = 20, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5034 12.3074C11.5214 12.3074 12.3495 11.4793 12.3495 10.4613C12.3495 9.44331 11.5214 8.61523 10.5034 8.61523C9.48542 8.61523 8.65735 9.44331 8.65735 10.4613C8.65735 11.4793 9.48542 12.3074 10.5034 12.3074ZM10.5034 9.84589C10.8428 9.84589 11.1189 10.122 11.1189 10.4613C11.1189 10.8007 10.8428 11.0768 10.5034 11.0768C10.1641 11.0768 9.888 10.8007 9.888 10.4613C9.888 10.122 10.1641 9.84589 10.5034 9.84589Z"
      fill="black"
    />
    <path
      d="M3.26416 13.4255C5.64898 15.1096 8.15219 15.9998 10.5034 15.9998C12.8547 15.9998 15.3579 15.1096 17.7427 13.4255C19.5266 12.1657 20.6138 10.9163 20.6594 10.8635L21.0069 10.4613L20.6594 10.0592C20.6141 10.0066 19.5266 8.75693 17.7427 7.49718C15.3579 5.81307 12.8547 4.92285 10.5034 4.92285C8.15219 4.92285 5.64898 5.81307 3.26416 7.49718C1.48027 8.75693 0.393003 10.0066 0.347488 10.0592L0 10.4613L0.347488 10.8635C0.392784 10.9163 1.48027 12.1657 3.26416 13.4255ZM17.0074 8.48444C18.0861 9.24326 18.9028 10.0107 19.3484 10.4613C18.9028 10.9122 18.0861 11.6794 17.0074 12.4382C16.4607 12.8226 15.8034 13.2336 15.0628 13.6017C15.6799 12.7087 16.0419 11.6266 16.0419 10.4613C16.0419 9.29605 15.6799 8.21393 15.0628 7.32092C15.8034 7.68908 16.4607 8.10003 17.0074 8.48444ZM10.5034 6.15372C12.8767 6.15372 14.811 8.08422 14.811 10.4613C14.811 12.8348 12.8803 14.7689 10.5034 14.7689C8.13014 14.7689 6.19582 12.8384 6.19582 10.4613C6.19582 8.08613 8.12823 6.15372 10.5034 6.15372ZM5.94516 7.31938C5.32737 8.21289 4.96495 9.29545 4.96495 10.4613C4.96495 11.6266 5.32693 12.7087 5.94406 13.6017C5.20341 13.2336 4.54612 12.8226 3.99945 12.4382C2.92099 11.6794 2.10402 10.9122 1.65867 10.4615C2.08329 10.0324 2.84659 9.31596 3.85716 8.58915C4.46915 8.14915 5.17179 7.70533 5.94516 7.31938Z"
      fill="black"
    />
    <path d="M11.1188 0H9.88794V3.07696H11.1188V0Z" fill="black" />
    <path
      d="M13.6406 3.42163L14.8708 0.961426L15.9711 1.51149L14.7409 3.97192L13.6406 3.42163Z"
      fill="black"
    />
    <path
      d="M17.3956 5.78476L19.2419 3.32324L20.2264 4.06155L18.3803 6.52329L17.3956 5.78476Z"
      fill="black"
    />
    <path
      d="M5.02673 1.50579L6.12702 0.955566L7.35724 3.41599L6.25695 3.96606L5.02673 1.50579Z"
      fill="black"
    />
    <path
      d="M0.780396 4.06176L1.76487 3.32324L3.61118 5.78476L2.62648 6.52329L0.780396 4.06176Z"
      fill="black"
    />
  </svg>
);